import * as React from 'react';
import { Button, Card, Image, Spinner } from "react-bootstrap";
import './DebicheckValidate.css';

export function DebicheckValidate(props: { title: string, emitHandleValidate: any, emitHandleBack?: any, success: boolean, error: any, saving?: boolean, }) {
    return (
        <Card className="debicheck-validate">
            <Card.Header>
                <Card.Title>
                    {props.title}
                </Card.Title>
            </Card.Header>
            <Card.Body>
                <div className="text-center">
                    <Image className="mt-1" src="./Images/LifeInsurance/debi-logo.png" />
                    { !props.error && <>
                        <p className="mt-3">We’ll be doing a same-day DebiCheck to protect you from unauthorised debit orders.You’ll get an alert from your bank to authorise and accept this debit order.</p>
                        <Button onClick={props.emitHandleValidate} className="debicheck-validate__validate btn btn-solid-red mt-3">
                            {!props.saving && <>Validate</>
                                ||
                                <Spinner className="d-block mx-auto" animation="border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </Spinner> }
                        </Button>
                    </>}
                    { props.error && <>
                        {props.error && <p className="mt-3 debicheck-validate__error-message">{ props.error.message }</p> }
                        <Button onClick={props.emitHandleBack} className="btn btn-solid-red mt-3">Back</Button>
                    </>}
                </div>
            </Card.Body>
        </Card>
    )
}